module.exports = __webpack_public_path__ + "f0bb7d5cf36cab0b6355a29bbd551d88.png";